'use client';

import { useEffect } from 'react';
import { sendGTMEvent } from '@/utils/analytics';

// Un único listener delegado: cualquier elemento con `data-gtm-event` empuja ese evento al
// dataLayer al hacer clic (con `data-gtm-source` como origen). Así los CTAs solo declaran
// atributos y no necesitan un onClick propio. Si GTM aún no cargó, el dataLayer lo acumula.
function onClick(e) {
  const el = e.target instanceof Element ? e.target.closest('[data-gtm-event]') : null;
  if (!el) return;
  const source = el.getAttribute('data-gtm-source') || undefined;
  sendGTMEvent({
    event: el.getAttribute('data-gtm-event'),
    source,
    cta_label: (el.getAttribute('aria-label') || el.textContent || '').trim().slice(0, 80),
    cta_location: source,
  });
}

export default function GtmClicks() {
  useEffect(() => {
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
  return null;
}
